/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import modules from "./modules";
import { isSuperAdmin } from "../../constants/user";
import { actions } from '../../store/reducers/authentication';
import { useNavigate } from "react-router-dom";
import Redirect from "../Redirect";
import Layout from "../Layout";
import { withHiddenApps } from "../../constants/apps";
import { CustomIcon } from "datastake-daf/dist/components";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import { useApplications } from "../../context/Applications";
import { getInterface, useApp } from "../../helpers/user";
import Loading from "../Loading";

const ModuleLoader = ({ user }) => {
  const { t } = useTranslation();
  const goTo = useNavigate();
  const app = useApp();
  const { applications } = useApplications();

  const onlyOneApp = useMemo(() => withHiddenApps.includes(app), [app]);

  const noRedirect = useMemo(() => modules.filter((mod) => mod.active && mod.isActive(user)).length > 1, [user]);

  const filteredApps = useMemo(() => {
    return applications
      .filter((c) => !!(user?.company?.apps || []).find((a) => onlyOneApp ? a.app === app && a.app === c.app && a.access : a.app === c.app && a.access))
      .map((c) => ({
        ...c,
        logo: `/assets/images/app-navigation/${c.app}-logo.svg`,
        description: typeof c.description === 'string' ? c.description : (c.description || {})[user?.language || 'en'] || '',
      }))
  }, [user, applications, onlyOneApp, app])

  const navigateToApp = (app = applications[0]) => {
    const _module = getInterface({ data: app, app: (user?.company?.apps || []).find((a) => a.app === app.app) });
    window.location.href = `${app.appLink}/app-redirect?module=${_module}&token=${StorageManager.get('token')}`
  };

  useEffect(() => {
    if (!noRedirect) {
      const _module = modules.find((mod) => mod.active && mod.isActive(user));
      if (_module) {
        goTo(_module.path);
      }
    }
  }, [noRedirect]);

  if (onlyOneApp) {
    return <Loading />;
  }

  return !isSuperAdmin(user) ? (
    <Layout module="app">
      <div className="module-wrapper-container">
        <div className="module-wrapper-header">
          <h1>{t('Datastake Applications')}</h1>
          <p>
            {t('Select the tool you want to use among those which your organisation has access to.')}
          </p>
        </div>

        <div className="flex justify-content-center">
          <div className="apps-container">
            {filteredApps.map((c) => (
              <div className="app" key={c.app} onClick={() => navigateToApp(c)}>
                <div className="app-header mb-4">
                  <img src={c.logo} alt={c.app} />
                  <div className="flex flex-column justify-content-center flex-1">
                    <h2 className="ml-4 mr-4">{c.title}</h2>
                  </div>
                  <div className="flex flex-column justify-content-center cursor-pointer">
                    <CustomIcon name="Link" width={21} height={21} color="white" />
                  </div>
                </div>

                <p>{t(c.description)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  ) : <Redirect to="/app/admin/users" />;
};

export default connect(({ authentication: { authenticated, user } }) => ({
  authenticated,
  user
}), actions)(ModuleLoader);
